import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth";
import { RequireAdmin } from "./components/RequireAdmin";
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { InstitutionsPage } from "./pages/InstitutionsPage";
import { CatalogHomePage } from "./pages/CatalogHomePage";
import { LoginPage } from "./pages/LoginPage";
import { MerchantIconsPage } from "./pages/MerchantIconsPage";
import { NetworksPage } from "./pages/NetworksPage";
import { ProductsPage } from "./pages/ProductsPage";
import { TypesPage } from "./pages/TypesPage";
import { AccountTypesPage } from "./pages/AccountTypesPage";
import { InvestmentAssetsPage } from "./pages/InvestmentAssetsPage";

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route element={<RequireAdmin />}>
            <Route path="/" element={<CatalogHomePage />} />
            <Route path="/institutions" element={<InstitutionsPage />} />
            <Route path="/networks" element={<NetworksPage />} />
            <Route path="/card-types" element={<TypesPage />} />
            <Route path="/account-types" element={<AccountTypesPage />} />
            <Route path="/investment-assets" element={<InvestmentAssetsPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/card-images" element={<Navigate to="/products" replace />} />
            <Route path="/merchant-icons" element={<MerchantIconsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
